import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateKeys = (params) => {
    return axios.post(`${backendHost}/api/admin/keys/create`, params);
};

export {
    postCreateKeys
}